import { useState, useEffect } from "react";
import { Drawer, Table, Tag, Statistic, Row, Col, Divider, Button, Popconfirm, Progress, Alert, notification } from "antd";
import axios from "axios";

import endpoints from "../../../../utils/endoinpts";

const columns = [
  {
    title: "Nome",
    dataIndex: "name",
  },
  {
    title: "E-mail",
    dataIndex: "email",
  },
  {
    title: "Tipo",
    dataIndex: "recipient_type",
    render: (type) => (type === "guest" ? "Convidado(a)" : "Sócio(a)"),
  },
  {
    title: "Estado",
    dataIndex: "status",
    render: (status) => <Tag color={status === "success" ? "green" : "red"}>{status === "success" ? "Enviado" : "Falhou"}</Tag>,
  },
  {
    title: "Detalhe do erro",
    dataIndex: "error_message",
  },
];

export default function EmailLogs({ data, open, close }) {
  const [isLoading, setIsLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [isResending, setIsResending] = useState(false);
  const [status, setStatus] = useState(null);
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    if (!open || !data) return;
    setStatus(data.status);
    setProgress(null);
    handleGetData(true);
  }, [open, data]);

  // While the communication is being sent, keep refreshing so the progress bar and the list move.
  useEffect(() => {
    if (!open || !data || status !== "sending") return;
    const interval = setInterval(() => handleGetData(false), 3000);
    return () => clearInterval(interval);
  }, [open, data, status]);

  function handleGetData(showLoading) {
    if (showLoading) setIsLoading(true);
    axios
      .get(endpoints.communications.emailLogs, { params: { id: data.id } })
      .then((res) => {
        setLogs(res.data.logs.map((item) => ({ ...item, key: item.id })));
        setStatus(res.data.status);
        setProgress(res.data.progress);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function handleResendFailed() {
    setIsResending(true);
    axios
      .post(endpoints.communications.resendFailed, { data: { id: data.id } })
      .then((res) => {
        notification.success({
          message: "Reenvio iniciado",
          description: `A reenviar para ${res.data.count} destinatário(s). Os envios são feitos a um ritmo controlado (cerca de 20 por minuto).`,
        });
        setIsResending(false);
        setStatus("sending");
        setProgress({ total: res.data.count, done: 0 });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Não foi possível reenviar",
          description: (err.response && err.response.data && err.response.data.message) || "Tente novamente daqui a pouco.",
        });
        setIsResending(false);
      });
  }

  let successCount = logs.filter((item) => item.status === "success").length;
  let errorCount = logs.filter((item) => item.status === "error").length;

  return (
    <Drawer title={`Registo de envios - ${data ? data.subject : ""}`} width={800} onClose={close} open={open}>
      {status === "pending" ? (
        <p>Esta comunicação ainda não foi enviada, por isso ainda não existe registo de envio.</p>
      ) : (
        <>
          {status === "sending" && progress && (
            <div className="mb-4">
              <Alert
                type="info"
                showIcon
                className="mb-3"
                message={`A enviar: ${progress.done}/${progress.total} e-mails (faltam ${Math.max(progress.total - progress.done, 0)})`}
                description="Os envios são feitos a um ritmo controlado (cerca de 20 por minuto). Pode fechar esta janela; o envio continua."
              />
              <Progress percent={progress.total > 0 ? Math.round((progress.done / progress.total) * 100) : 0} status="active" />
            </div>
          )}
          {status === "error" && (
            <Alert type="warning" showIcon className="mb-3" message="O envio foi interrompido ou terminou com falhas. Use o botão abaixo para enviar a quem ainda não recebeu." />
          )}
          <Row className="mb-4">
            <Col span={8}>
              <Statistic title="Total de destinatários" value={logs.length} />
            </Col>
            <Col span={8}>
              <Statistic title="Enviados com sucesso" value={successCount} valueStyle={{ color: "#3f8600" }} />
            </Col>
            <Col span={8}>
              <Statistic title="Falharam" value={errorCount} valueStyle={{ color: errorCount > 0 ? "#cf1322" : undefined }} />
            </Col>
          </Row>
          {(status === "error" || (status === "sent" && errorCount > 0)) && (
            <Popconfirm
              title="Reenviar a comunicação a quem ainda não recebeu?"
              description="Quem já recebeu não volta a receber."
              okText="Reenviar"
              cancelText="Cancelar"
              onConfirm={handleResendFailed}
            >
              <Button type="primary" size="large" loading={isResending}>
                Reenviar aos que falharam{errorCount > 0 ? ` (${errorCount})` : ""}
              </Button>
            </Popconfirm>
          )}
          <Divider />
          <Table columns={columns} dataSource={logs} loading={isLoading} />
        </>
      )}
    </Drawer>
  );
}
